import { forwardRef, type ReactNode } from "react";
import { cn } from "@/lib/cn";
import { RevealAndCopy, type RevealAndCopyProps } from "@/components/ui/patterns/RevealAndCopy";

export type RevealFieldProps = Omit<RevealAndCopyProps, "className"> & {
  label?: ReactNode;
  helperText?: ReactNode;
  errorText?: ReactNode;
  className?: string;
  fieldClassName?: string;
};

export const RevealField = forwardRef<HTMLDivElement, RevealFieldProps>(({ className, fieldClassName, label, helperText, errorText, ...props }, ref) => (
  <div ref={ref} className={cn("bfrs-grid bfrs-gap-1.5", className)}>
    {label && <span className="bfrs-text-xs bfrs-font-semibold bfrs-text-text-primary">{label}</span>}
    <div className={cn("bfrs-flex bfrs-h-9 bfrs-items-center bfrs-rounded-lg bfrs-border bfrs-border-border-control bfrs-bg-surface-card bfrs-px-3", errorText && "bfrs-border-danger", fieldClassName)}>
      <RevealAndCopy {...props} className="bfrs-w-full" />
    </div>
    {(helperText || errorText) && <span className={cn("bfrs-text-xs bfrs-leading-5", errorText ? "bfrs-text-danger" : "bfrs-text-text-muted")}>{errorText ?? helperText}</span>}
  </div>
));

RevealField.displayName = "RevealField";
